<template>
        <div class="edits setting">
            <div class="setting-h1">
                Email Address
            </div>
            <div class="setting-h2">
                Edit your Email Address. You will be logged out and sent a verification link to your new Email Address
            </div>
        <form @submit.prevent="editEmail">
    
        <div class="mb-3">
            <label class="form-label">Email Address</label>
            <input type="text" v-model="user.newEmail" class="form-control">
        </div>      
         <div class="form-buttons mb-3">
                <button type="submit" class="btn btn-default primary-btn" v-if="loading" disabled>Saving Email...</button>
                <button type="submit" class="btn btn-default primary-btn" v-else>Save Email Address</button>
            </div>
               <!-- errors -->
        <div class="errors" v-if="hasErrors">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors --> 
        </form>
        <!-- <LoadingIndicator v-if="loading"/> -->
        </div>
        <CustomConfirmationMessageModal :title="modal.caption"
         :body="modal.message"
          :button-label="modalButtonLabel"
           :close-modal="() => closeModal()"
           :modal-id="modalId"/>
</template>
<script>
import { editEmailAsync } from '@/services/accountService';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal';

export default {
    components:{
        CustomConfirmationMessageModal
    },
    data(){
        return{
            url: process.env.VUE_APP_API_URL,
            user:{
                    newEmail:"",           
                    oldEmail:"",           
                },
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            errors:[],
            loading:false,
            hasErrors:false,
            modalButtonLabel:'Close',
            modalId:"editEmail"
            
        }
    },
    mounted(){
        this.confirmModal = new Modal(document.getElementById(`${this.modalId}`))
    },
     created(){
          // Hydrate local user object from Vuex
        const authUser = this.$store.getters['auth/getAuthenticatedUser'];
        if (authUser) {
            this.user.newEmail = authUser.email || "";
            this.user.oldEmail = authUser.email || "";
        }
    },
    methods:{
     async editEmail(){
        try{
            this.resetOnNewSubmit();
            var data = await editEmailAsync(this.user);
            this.loading = false;
            if(data.success){
                //this.$store.dispatch('auth/updateProfile', { user: this.user });
                this.modal.caption = data.caption;
                this.modal.message = data.message;
                this.showModal();
                this.$store.dispatch('auth/logout');
                this.$router.push('/login');
        }else{
            if(data.errors){
                   data.errors.forEach((err) => {
                    this.errors.push(err);
                });
                this.hasErrors = true;
                return;
            }
           
             throw new Error(data.message, {cause: data.caption})
        }
        }catch(e){
            this.loading = false;
            let message = e.message || "Something went wrong. Please try later";
            this.errors.push(message);
            this.hasErrors = true;
            // this.modal.caption = e.cause || "Error";
            // this.modal.message = e.message || "Something went wrong. Please try later";
            // this.modalButtonLabel = 'Close'
            // this.showModal();
        }     
        },
        resetOnNewSubmit(){
                this.loading = true;
                this.hasErrors = false;
                this.errors = [];
        },
        closeModal(){
        this.confirmModal.hide();
        },
        showModal(){
            this.confirmModal.show();
        }
   }
}
</script>
<style scoped>

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>